/*
 * Description: Display Call to Action Web Component
 * Purpose: Displays a styled call-to-action button/link
 * Author: Nuvemx
 * Created: 2026
 *
 * Features:
 * - Configurable variant (primary, secondary, success, danger)
 * - Arrow icon indicator
 * - Configurable title and URL
 *
 * Usage:
 * <display-cta title="Get Started" url="/signup" variant="success"></display-cta>
 * <display-cta title="Learn More" url="/about"></display-cta>
 *
 * Attributes:
 * - title: String - Button text (required)
 * - url: String - Destination URL (required)
 * - variant: String - Button style: 'primary', 'secondary', 'success', 'danger' (default: 'primary')
 *
 */

import './display_cta.css';

class display_cta extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const title = this.getAttribute('title') || 'Click Here';
        const url = this.getAttribute('url') || '#';
        const variant = this.getAttribute('variant') || 'primary';

        this.innerHTML = `
            <div class="cta-wrapper my-3">
                <a href="${url}" class="btn btn-${variant} btn-lg px-4">
                    ${title}
                    <i class="bx bx-right-arrow-alt ms-1"></i>
                </a>
            </div>`;
        this.dataset.rendered = "true";
    }
}

export { display_cta };
